import { TextDTO, TextReadabilityDTO } from '@/utils/types/text';
import { Paragraph } from '@/utils/types/common';
import { DocumentRepo } from '@/utils/types/documentRepo/documentRepo';
import {
  DocumentRepoCommitDTO,
} from '@/utils/types/documentRepo/documentRepoCommit';
import { ComponentVersion } from '@/utils/types/documentRepo/history';
import { DocumentParagraph } from '@/utils/types/documentRepo/documentComponent';

export interface RootState {
  text: TextState;
  documentRepo: DocumentRepoState;
  documentComponents: DocumentComponentsState;
  ui: UIState;
}

// Common types and interfaces
export type CommitId = string;
export interface DocIdCommitId {
  docId: string;
  commitId: CommitId;
}
export interface PrevCurrNextCommitId {
  docId: string;
  prevId?: CommitId;
  currId: CommitId;
  nextId?: CommitId;
}

export interface PollingState {
  pollingIntervalId: number | undefined;
}

export interface TextState {
  // All texts
  texts: TextDTO[];
  // Currently viewed text
  text: TextDTO;
  // Currently selected paragraph
  paragraph: Paragraph;
  // Readability of currently viewed text
  textReadability: TextReadabilityDTO;
}

export enum DocumentRepoChartTab {
  ByRevision = 0,
  ByParagraph = 1,
}

export interface DocumentRepoState extends PollingState {
  // All document repos
  documentRepos: DocumentRepo[];
  // Currently viewed document repo
  documentRepo: DocumentRepo;
  // Revisions of currently viewed document repo
  documentRepoCommits: DocumentRepoCommitDTO[];
  // Currently viewed document revision
  documentRepoCommit: DocumentRepoCommitDTO;
  // Currently selected tab
  selectedChartTab: DocumentRepoChartTab;
}

export type HistoryNestedMap = Record<CommitId, Record<string, ComponentVersion>>;
export interface DocumentComponentsState {
  // History of document repo (map of componentId to ComponentVersion, by DocumentRepoCommit id)
  documentHistoryMap: HistoryNestedMap;
  // DocumentParagraphs by DocumentRepoCommit id
  documentParagraphsByCommitId: Record<CommitId, DocumentParagraph[]>;
  // Index of selected DocumentParagraph
  selectedParagraphIndex: number | undefined;
  // Selected DocumentParagraph
  currParagraph: DocumentParagraph | undefined;
  // Previous DocumentParagraph in history (from currentParagraph)
  prevParagraph: DocumentParagraph | undefined;
  // Next DocumentParagraph in history (from currentParagraph)
  nextParagraph: DocumentParagraph | undefined;
}

export interface UIState {
  // Whether the document repo inspection modal is active
  isDocumentInspectionModalActive: boolean;
}
